import { connect } from 'react-redux';

import Footer from './footer.component';
import { IFooterStoreProps } from './footer.types';
import { State } from 'widgets/free-content/root/root.reducers';

const mapStateToProps = (state: State): IFooterStoreProps => ({
    ratingsConfig: state.config.ageRatings,
    countryCode: state.IPLocation?.data?.countryCode ?? ''
});

export default connect(mapStateToProps)(Footer);
